import { render } from "./SmallColoredCheck.vue?vue&type=template&id=50c199d7"
import script from "./SmallColoredCheck.vue?vue&type=script&lang=js"
export * from "./SmallColoredCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__